import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

export type RequestSummaryItem = {
  label: string
  value: string
}

export function RequestSummaryPanel({
  title,
  items,
  action,
  className,
}: {
  title: string
  items: RequestSummaryItem[]
  action?: ReactNode
  className?: string
}) {
  return (
    <aside
      className={cn(
        'rounded-[var(--brand-radius-card)] border border-[var(--brand-border)] bg-[var(--brand-surface)] p-4 shadow-[var(--brand-shadow-1)]',
        className,
      )}
      aria-label={title}
    >
      <h2 className="font-sans text-[20px] font-semibold text-[var(--brand-text-primary)]">{title}</h2>
      <dl className="mt-4 space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex items-start justify-between gap-4 text-sm">
            <dt className="text-[var(--brand-text-secondary)]">{item.label}</dt>
            <dd className="text-right font-medium text-[var(--brand-text-primary)]">{item.value}</dd>
          </div>
        ))}
      </dl>
      {action ? <div className="mt-4">{action}</div> : null}
    </aside>
  )
}
